/**
 * @ngdoc directive
 * @name WcResponsiveTableModule.directive:wcRowActionMultiple
 * @restrict A
 * @scope
 * @param {string} wcRowActionMultiple The parameter holds the multiple row action values
 * @description
 * The wcRowActionMultiple directive is responsible for the multiple actions that are carried out in the datatable.
 */



angular.module('WcResponsiveTableModule').directive('wcRowActionMultiple', function() {
	return {
		restrict: 'A',
		require: ['wcRowActionMultiple', '?^wcResponsiveTable'],
		scope: {},
		bindToController: {
			wcRowActionMultiple: '@'
		},
		controllerAs: 'rowActionMultipleController',
		controller: ['$scope', '$element', function ($scope, $element) { //jshint unused:true
			var responsiveTableController = $element.parent().controller('wcResponsiveTable');

			this.multipleAction = function() {
				var ngModel = responsiveTableController.ngModel;
				var viewScope = responsiveTableController.WcTableScopeService.getParentScope();

				if(ngModel.length) {
					viewScope.$broadcast(this.wcRowActionMultiple, [].concat(ngModel));
				}
			};
		}],
		link: function (scope, element, attrs, controllers) { //jshint unused:true
			var rowActionMultipleController = controllers[0];

			element.on('click', function() {
				rowActionMultipleController.multipleAction();
			});
		}
	};
});